/**
 * @module collectionTypeUtils
 */

/**
 * Convenience function to convert the specified collection type to a path-ready value.
 *
 * @param {string} type - The media collection type.
 *
 * @returns {string} The converted type as path-ready value (e.g. 'messages').
 */
function collectionTypeToPath(type) {
  let path = type;
  switch (type) {
    case 'weekend_message':
      path = 'messages';
      break;
    case 'early_childhood':
      path = 'early-childhood';
      break;
    case 'leadership_podcast':
      path = 'leadershippodcast';
      break;
    case 'life_groups':
      path = 'lifegroups';
      break;
    case 'story':
      path = 'stories';
      break;
    default:
      break;
  }
  return path;
}

module.exports = {
  collectionTypeToPath,
};
